
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/abuse/how-we-handle",
      function () {
        return require("private-next-pages/terms/abuse/how-we-handle.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/abuse/how-we-handle"])
      });
    }
  